import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import TransferMultiplierGuide from "@/pages/profile/TransferMultiplierGuide";
import { createFileRoute } from "@tanstack/react-router";

type TransferMultiplierGuideRouteSearch = {
	from?: "player-auction";
};

export const Route = createFileRoute(
	"/_dashboard/profile/transfer-multiplier-guide",
)({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
	validateSearch: (
		search: Record<string, unknown>,
	): TransferMultiplierGuideRouteSearch => ({
		from: search.from === "player-auction" ? "player-auction" : undefined,
	}),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<TransferMultiplierGuide />
		</DashboardLayout>
	);
}
